import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class Stagger {
	constructor(triggers, from, to) {

		this.triggers = triggers
		this.from = from
		this.to = to
		this.getDom()

		if (!this.dom.triggers.length) return

		gsap.registerPlugin(ScrollTrigger);

		this.init()
	}

	getDom() {
		this.dom = {
			triggers: this.triggers
		}
	}

	init() {
		gsap.fromTo(this.dom.triggers, {
				...this.from,
			},
			{
				...this.to,
				stagger: 0.2,
				duration: this.to.duration,
				ease: 'easeInOut',
				scrollTrigger: {
					once: true,
					trigger: this.dom.triggers,
					start: 'top bottom-=20%',
				},
			})
	}
}
